<template>
  <main>
    <tab-authorize-header />
    <div class="tab-content" :class="{'section-loading': isLoading}">
      <div class="tab-pane active show">
        <div class="container">
          <table  class="mt-5 table datatable insurance-green table-striped table-bordered">
            <thead>
              <tr>
                <th class="text-center">
                    授權對象
                </th>
                <th class="text-center">
                    單位佈告欄
                </th>
                <th class="text-center">
                    單位條件設定
                </th>
                <th class="text-center">
                    服務件調撥
                </th>
                <th class="text-center w-220">
                    功能
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rid) in authizeData" :key="`row-${rid}`">
                <td class="text-center">{{ row.name }}</td>
                <td v-if="currentTableIndex !== rid" class="text-center" v-html="booleanFormat(row.function_id.includes('1'))">
                  
                </td>
                <td v-else class="text-center" >
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" :id="`servie-${rid}`" v-model="row.status1" />
                    <label :for="`servie-${rid}`"></label>
                  </div>
                </td>
                <td v-if="currentTableIndex !== rid" class="text-center" v-html="booleanFormat(row.function_id.includes('2'))">

                </td>
                <td v-else class="text-center" >
                  <div class="checkbox checkbox-inline"> 
                    <input type="checkbox" :id="`unit_condition-${rid}`" v-model="row.status2" />
                    <label :for="`unit_condition-${rid}`"></label>
                  </div>
                </td>
                <td v-if="row.user_category_id =='A045' || row.user_category_id =='A015'" class="text-center" >
                  無法授權      
                </td>
                <td v-else-if="currentTableIndex !== rid" class="text-center" v-html="booleanFormat(row.function_id.includes('3'))">

                </td>
                <td v-else class="text-center" >
                  <div class="checkbox checkbox-inline"> 
                    <input type="checkbox" :id="`service-${rid}`" v-model="row.status3" />
                    <label :for="`service-${rid}`"></label>
                  </div>
                </td>
                <td class="text-center">
                  <div class="text-green text-underline pointer-cursor m-1 line-height-26px" @click="onEdit(rid)" v-if="currentTableIndex !== rid">{{ functionName }}</div>
                  <span v-else @click="onSave(row,rid)"><button class="btn btn-primary btn-sm m-1">儲存</button></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <warning-modal
    :open="warningModalOpen"
    :message="warningMessage"
    @close="close"
    @submit="saveAuthorize" />
  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import {getAuthorizedPersonnel,setPermissionsAuthorized} from '@/service'
import TabAuthorizeHeader from './components/TabAuthorizeHeader'
import WarningModal from '@/desktop/components/WarningModal';
import { log } from 'util';


export default {
  name: 'AuthorizeTab1',
  mixins: [commonMixin],
  components: {
    TabAuthorizeHeader, WarningModal
  },

  data () {
    return {
      isLoading: false,
      // isLoading: false,
      warningModalOpen: false,
      warningMessage: '你是否確認要儲存此設定？',
      store_data: [],
      edit_id: null,
      authizeData:[],
      functionName: '授權設定',
      lists : [],
      functionCheck: false,
      form:{},
      currentTableIndex: '',
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    booleanFormat(value) {
      if(!!value === true) {
        return '<span><i class="icon-check mr-2 font-weight-bold"></i>已授權</span>';
      }else{
        return '<span><i class="icon-close mr-2 text-danger font-weight-bold"></i>未授權</span>';
      }
    },
    onEdit(index) {
      this.currentTableIndex = index
    },
    onSave(row, rid) {  
      let form = {
        div_full_name: row.div_full_name,
        name: row.name,
        employee_id: row.employee_id,
        div_no: row.div_no,
        user_category_id: row.user_category_id,
      }
      let lists = []
      let function_listData1 = {}
      let function_listData2 = {}
      let function_listData3 = {}
      this.functionCheck = true
      if(row.function_id.includes('1') != row.status1 && row.function_id.includes('2') != row.status2 && row.function_id.includes('3') != row.status3){
          function_listData1 = {
            function_id :'1',
            status: row.status1 == true ? "add" : "del"
          }, 
          function_listData2 = {
            function_id :'2',
            status: row.status2 == true ? "add" : "del"
          }, 
          function_listData3 = {
            function_id :'3',
            status: row.status3 == true ? "add" : "del"
          }, 
            lists.push(function_listData1)
            lists.push(function_listData2)
            lists.push(function_listData3)
      }else if(row.function_id.includes('1') != row.status1 && row.function_id.includes('2') != row.status2){
          function_listData1 = {
            function_id :'1',
            status: row.status1 == true ? "add" : "del"
          },
           function_listData2 = {
            function_id :'2',
            status: row.status2 == true ? "add" : "del"
          }, 
            lists.push(function_listData1)
            lists.push(function_listData2)
      }else if(row.function_id.includes('1') != row.status1 && row.function_id.includes('3') != row.status3){
          function_listData1 = {
            function_id :'1',
            status: row.status1 == true ? "add" : "del"
          },
          function_listData3 = {
            function_id :'3',
            status: row.status3 == true ? "add" : "del"
          }, 
            lists.push(function_listData1)
            lists.push(function_listData3)
      }else if(row.function_id.includes('2') != row.status2 && row.function_id.includes('3') != row.status3){
        function_listData2 = {
            function_id :'2',
            status: row.status2 == true ? "add" : "del"
          },
        function_listData3 = {
            function_id :'3',
            status: row.status3 == true ? "add" : "del"
          },
          lists.push(function_listData2)
          lists.push(function_listData3) 
      }else if(row.function_id.includes('1') != row.status1){
        function_listData1 = {
            function_id :'1',
            status: row.status1 == true ? "add" : "del"
          }, 
        lists.push(function_listData1)
      }else if(row.function_id.includes('2') != row.status2){
        function_listData2 = {
            function_id :'2',
            status: row.status2 == true ? "add" : "del"
          }, 
        lists.push(function_listData2)
      }else if(row.function_id.includes('3') != row.status3){
        function_listData3 = {
            function_id :'3',
            status: row.status3 == true ? "add" : "del"
          }, 
        lists.push(function_listData3)
      }else{
          this.functionCheck = false
      }
        this.form = form
        this.lists = lists
        this.warningModalOpen = true
        this.currentTableIndex = ''
      },
    saveAuthorize() {
      if(this.functionCheck){
        this.isLoading = true
        setPermissionsAuthorized(this.$store.state.userInfo.id,this.form,this.lists).then(result =>{
          if(result.header && result.header.status == '200') {
              this.$toast.info({title: '已更改授權'})
          } else {
            if(result.header && result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '已更改授權'})
            }
          }
          this.panelClose('warningModalOpen')
          this.isLoading = false
          this.init()
         })        
      }else{
          this.$toast.info({title: '已更改授權'})
          this.panelClose('warningModalOpen')
      }
    },
    init(){

      this.isLoading = true
       getAuthorizedPersonnel(this.$store.state.userInfo.id,this.$store.state.userInfo.divNo).then(result => {
        if(result.header && result.header.status == '200') {
            this.authizeData = result.body.lists.map(itme => {
              return {
                ...itme,
                status1: itme.function_id.includes('1') ? true : false,
                status2: itme.function_id.includes('2') ? true : false,
                status3: itme.function_id.includes('3') ? true : false,
              }
            })
        } else {
          if(result.header && result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '查詢滿意度調查失敗,請重新操作'})
          }
        }
        this.isLoading = false
       }) 
    },
    close() {
      this.panelClose('warningModalOpen')
    }
  },
  beforeMount () {
  },
  mounted () {
   
    this.init()
  }
}
</script>
